import { lazy, Suspense } from 'react'
import { createHashRouter, Navigate, redirect } from 'react-router-dom'
import { globalState } from '@/store'
import Home from '@/pages/Home'
import Chat from '@/pages/chat'
const lazyElement = (
  factory: () => Promise<{
    default: () => JSX.Element | null
  }>,
  props?: any,
) => {
  const Element = lazy(() => factory())
  return (
    <Suspense>
      <Element {...props} />
    </Suspense>
  )
}

const shouldLoginLoader = () => {
  if (!globalState.userInfo.authCode) {
    return redirect('/login')
  }
  return null
}

const router = createHashRouter([
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/',
    loader: shouldLoginLoader,
    element: lazyElement(() => import('@/pages/layout')),
    children: [
      {
        path: '/chat',
        // element: lazyElement(() => import('@/pages/chat')),
        element: <Chat />,
      },
      {
        path: '/knowledge',
        element: lazyElement(() => import('@/pages/chatdoc')),
      },
      {
        path: '/assistant',
        element: lazyElement(() => import('@/pages/assistant')),
        children: [
          {
            index: true,
            element: lazyElement(() => import('@/pages/assistant/Recommend1')),
          },
          {
            path: 'user',
            element: lazyElement(() => import('@/pages/assistant/Self1')),
          },
          {
            path: 'like',
            element: lazyElement(() => import('@/pages/assistant/Collection')),
          },
        ],
      },

      {
        path: '/assistant/playground',
        element: lazyElement(() => import('@/pages/assistant/playground')),
      },
      {
        path: '/assistant/edit',
        element: lazyElement(() => import('@/pages/assistant/agentTest')),
      },
      {
        path: '/assistant/detail/:appId',
        element: lazyElement(() => import('@/pages/assistant/detail/index')),
      },
      {
        path: '/writing',
        element: lazyElement(() => import('@/pages/writing')),
      },
      {
        path: '/appSet',
        element: lazyElement(() => import('@/pages/appSet')),
      },
      {
        path: '/appSet/arxivTrans',
        element: lazyElement(() => import('@/pages/appSet/trans')),
      },
      {
        path: '/appSet/academicTrans',
        element: lazyElement(() => import('@/pages/appSet/fanyi')),
      },
      {
        path: '/appSet/academicPolish',
        element: lazyElement(() => import('@/pages/appSet/polish')),
      },
      {
        path: '/appSet/paperRead',
        element: lazyElement(() => import('@/pages/appSet/paperRead')),
      },
      {
        path: '/appSet/paperRead/:paperId',
        element: lazyElement(() => import('@/pages/appSet/paperRead/detail')),
      },
      {
        path: '/appSet/pptGenerate',
        element: lazyElement(() => import('@/pages/appSet/pptGenerate')),
      },
      {
        path: '/appSet/pptGenerate/preview',
        element: lazyElement(
          () => import('@/pages/appSet/pptGenerate/preview'),
        ),
      },
      {
        path: '/appSet/pptGenerate/edit',
        element: lazyElement(() => import('@/pages/appSet/pptGenerate/edit')),
      },
      {
        path: '/appSet/pptGenerate/tpl',
        element: lazyElement(
          () => import('@/pages/appSet/pptGenerate/template'),
        ),
      },
      {
        path: '/appSet/search',
        element: lazyElement(() => import('@/pages/appSet/search')),
      },
      // {
      //   path: '/appSet/search/detail',
      //   element: lazyElement(() => import('@/pages/appSet/search/detail')),
      // },
      {
        path: '/appSet/rtasr',
        element: lazyElement(() => import('@/pages/appSet/rtasr')),
      },
      {
        path: '/appSet/rtasr/:type',
        element: lazyElement(() => import('@/pages/appSet/rtasr/asr')),
      },
    ],
  },
  {
    path: '/status',
    element: lazyElement(() => import('@/pages/status')),
  },
  {
    path: '/login',
    element: lazyElement(() => import('@/pages/login/AuthcodeLogin')),
  },
  {
    path: '/loginByPassword',
    element: lazyElement(() => import('@/pages/login')),
  },
  {
    path: '/signup',
    element: lazyElement(() => import('@/pages/signup')),
  },
  // {
  //   path: '/audit',
  //   element: lazyElement(() => import('@/pages/signup/Audit')),
  // },
  // {
  //   path: '/auditPass',
  //   element: lazyElement(() => import('@/pages/signup/AuditPass')),
  // },
  {
    path: '/downloadPPT/:id',
    element: lazyElement(() => import('@/pages/downloadPPT')),
  },
  {
    path: '/download',
    element: lazyElement(() => import('@/pages/download')),
  },
  {
    path: '/share/:id',
    element: lazyElement(() => import('@/pages/share')),
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
])

export default router
